export const RESPONSE_TIME_EVENTS = ['sspBidResponse', 'dspBidResponseBid', 'dspBidResponseNoBid'] as const;

export type ResponseTimeEvent = (typeof RESPONSE_TIME_EVENTS)[number];

export const RESPONSE_TIME_METRICS = [
  'p50',
  'min',
  'mean',
  'p10',
  'p15',
  'p25',
  'p75',
  'p90',
  'p95',
  'max',
  'totalResponses',
] as const;

export type ResponseTimeMetric = (typeof RESPONSE_TIME_METRICS)[number];

export interface ResponseTimeHistoryParams {
  event: ResponseTimeEvent;
  from: string; // ISO datetime (UTC)
  to: string;
  partnerId?: number[];
  bucket?: number;
}

export interface ResponseTimeHistoryRow {
  t: string; // 'YYYY-MM-DD HH:mm:ss' UTC bucket start
  partnerId: number;
  partnerLabel: string;
  min: number;
  mean: number;
  p10: number;
  p15: number;
  p25: number;
  p50: number;
  p75: number;
  p90: number;
  p95: number;
  max: number;
  totalResponses: number;
}

export interface ResponseTimeHistoryResponse {
  bucketMinutes: number;
  rows: ResponseTimeHistoryRow[];
}
